import {literalUnion, nullable} from '@raison/io-ts-tools';
import {BaseCurrencyCode, DoubleString, NonEmptyString, PositiveInt} from '@raison/types';
import {Branded, TypeOf, array, brand, string, type} from 'io-ts';

interface ISINBrand {
    readonly ISIN: unique symbol;
}

export const ISIN = brand(string, (n): n is Branded<string, ISINBrand> => n.length === 12, 'ISIN');
export type ISIN = TypeOf<typeof NonEmptyString>;

export const LogoSchema = type({
    vector_small: nullable(NonEmptyString),
    vector_big: nullable(NonEmptyString),
    raster_small: nullable(NonEmptyString),
    raster_big: nullable(NonEmptyString),
});

export type LogoSchema = TypeOf<typeof LogoSchema>;

export type InstrumentType = TypeOf<typeof InstrumentType>;
const InstrumentType = literalUnion('stock', 'etf', 'bond', 'note');

export const BalanceSchema = type({
    id: PositiveInt,
    symbol: NonEmptyString,
    type: InstrumentType,
    ticker: nullable(string),
    currency: BaseCurrencyCode,
    isin: nullable(ISIN),
    qty: DoubleString,
    current_value: DoubleString,
    dynamics: DoubleString,
    issuer_name: NonEmptyString,
    asset_name: nullable(NonEmptyString),
    maturity_date: nullable(NonEmptyString),
    coupon_rate: nullable(NonEmptyString),
    logo: LogoSchema,
});
export type BalanceSchema = TypeOf<typeof BalanceSchema>;

export const BalancesSchema = array(BalanceSchema);
export type BalancesSchema = TypeOf<typeof BalancesSchema>;
